<ng-template #rt let-r="result" let-t="term">
  <div class="item-search-select">
    @if (r.season - ticketsstation?.stationCode) {
      <span class="item-dest">
        {{ r.name | flightFormat }} ({{ r.season - ticketsstation?.stationCode }})
      </span>
    }
    @if (!r.season - ticketsstation?.stationCode) {
      <span class="item-dest">{{ r.name }}</span>
    }
  </div>
</ng-template>

<div id="SeasonTicketsSearchForm">
  <div class="inputs-container">
    <div class="half-container">
      <div class="half-block">
        <label
          class="header-label"
          for="season-tickets-travel-from-input"
          i18n="@@season-ticketsSearchTravellingFrom"
        >
          From
        </label>
        <i class="ico-rail combo-box-icon" aria-hidden="true"></i>
        <div class="flex-row-container">
          <input
            autocomplete="off"
            type="text"
            id="season-tickets-travel-from-input"
            i18n-placeholder
            placeholder="Enter a station"
            (click)="$event.target.select()"
            appInput
            name="fromLocation"
            [ngbTypeahead]="railLocations"
            [(ngModel)]="searchParams.fromLocation"
            [resultTemplate]="rt"
            [inputFormatter]="formatter"
            tabindex="0"
            (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
            (keyup.arrowup)="ensureElementIsScrolledTo($event)"
            [hasError]="searchParams.validationMessages?.includes('Please Enter a From Location')"
          />
        </div>
      </div>
      <div class="half-block">
        <label
          class="header-label"
          for="season-tickets-travel-to-input"
          i18n="@@railSearchTravellngTo"
        >
          To
        </label>
        <i class="ico-rail combo-box-icon" aria-hidden="true"></i>
        <div class="flex-row-container">
          <input
            autocomplete="off"
            type="text"
            id="season-tickets-travel-to-input"
            i18n-placeholder
            placeholder="Enter a station"
            (click)="$event.target.select()"
            appInput
            name="toLocation"
            [ngbTypeahead]="railLocations2"
            [(ngModel)]="searchParams.toLocation"
            [resultTemplate]="rt"
            [inputFormatter]="formatter"
            tabindex="0"
            (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
            (keyup.arrowup)="ensureElementIsScrolledTo($event)"
            [hasError]="searchParams.validationMessages?.includes('Please Enter a To Location')"
          />
        </div>
      </div>
    </div>

    <div class="half-container flex-start">
      <div class="half-block">
        <label
          class="header-label date-label"
          for="season-tickets-StartDate"
          i18n="@@season-tickets-StartDate"
          >Start date (DD/MM/YYYY)</label
        >
        <ngbd-datepicker-i18n>
          <i class="ico-calendar combo-box-icon cursor_pointer" aria-hidden="true"></i>
          <app-datepicker
            [class]="'combo-box'"
            [componentId]="'season-tickets-StartDate'"
            [minDate]="searchParams.minStartDate"
            [startDate]="searchParams.startDate"
            [model]="searchParams.startDate_ngb"
            (newDate)="searchParams.startDate_ngb = $event"
          >
          </app-datepicker>
        </ngbd-datepicker-i18n>
      </div>
    </div>

    <div class="half-container pt-4">
      <div class="flex-column-container">
        <label id="seasonTicketType" class="header-label" i18n="@@seasonTicketType"
          >Select season ticket type</label
        >
        <div class="flex-row-container">
          <mat-radio-group
            [(ngModel)]="searchParams.ticketType"
            aria-label="return flight time preferences"
          >
            @for (seasonTicketType of searchParams.seasonTicketTypes; track seasonTicketType) {
              <mat-radio-button
                class="light-primary time-option"
                aria-labelledby="seasonTicketType"
                color="primary"
                [value]="seasonTicketType.value"
              >
                {{ seasonTicketType.display | translate }}
              </mat-radio-button>
            }
          </mat-radio-group>
        </div>
      </div>
    </div>

    <!-- options -->
    <div class="flex-column-container">
      <h2 class="header-label rem-1-5" i18n="@@seasonTicketsSearchOptions">Options</h2>
      <div class="half-container">
        <div class="half-block">
          @if (seasonTicketsOysterCardsConfig) {
            <div class="half-container">
              <div class="half-block">
                <label i18n="@@TicketCardType" for="season-tickets-card-type">
                  Ticket card type
                </label>
                <select
                  class="combo-box"
                  [(ngModel)]="searchParams.ticketCardType"
                  id="season-tickets-card-type"
                >
                  @for (
                    seasonTicketType of searchParams.seasonTicketCardTypes;
                    track seasonTicketType
                  ) {
                    <option [value]="seasonTicketType.value">
                      {{ seasonTicketType.display | translate }}
                      <!-- add translations -->
                    </option>
                  }
                </select>
              </div>
              @if (
                searchParams.ticketCardType === SeasonTicketCardType.NewOysterCard ||
                searchParams.ticketCardType === SeasonTicketCardType.OysterTopUp
              ) {
                <div class="half-block">
                  <label
                    i18n="@@seasonTicketsOysterCardNumber"
                    for="season-tickets-oystercard-number"
                  >
                    Oyster card number
                  </label>
                  <input
                    type="text"
                    id="season-tickets-oystercard-number"
                    appInput
                    name="oysterCard"
                    [(ngModel)]="searchParams.oysterCardNumber"
                  />
                </div>
              }
            </div>
          }
          <div class="half-container pt-4">
            <div class="half-block">
              <label i18n="@@carsClass" for="season-tickets-select-class">Class</label>
              <select
                class="combo-box"
                [(ngModel)]="searchParams.classOfService"
                id="season-tickets-select-class"
              >
                @for (serviceClass of searchParams.seasonTicketClassTypes; track serviceClass) {
                  <option [value]="serviceClass.value">
                    {{ serviceClass.display | translate }}
                  </option>
                }
              </select>
            </div>
            <div class="half-block">
              <label i18n="@@season-ticketsRailOperator" for="season-tickets-rail-operator">
                Rail operator
              </label>
              <select
                class="combo-box"
                [(ngModel)]="searchParams.railOperator"
                id="season-tickets-rail-operator"
              >
                <option value="" i18n="@@SeasonTicketAny">Any</option>
                @for (operator of searchParams.railOperators; track operator) {
                  <option [value]="operator">
                    {{ operator }}
                  </option>
                }
              </select>
            </div>
          </div>
          <div class="half-container pt-4">
            <div class="half-block">
              <label
                i18n="@@seasonTicketsUndergroundRequired"
                for="season-tickets-underground-required"
              >
                Is London underground required
              </label>
              <select
                class="combo-box"
                [(ngModel)]="searchParams.isLondonUndergroundRequired"
                id="season-tickets-underground-required"
              >
                <option value="null" i18n="@@SeasonTicketSelectfromdropdown" selected="selected">
                  Select from dropdown
                </option>
                @for (
                  undergroundZone of searchParams.seasonTicketLondonUndergroundZones;
                  track undergroundZone
                ) {
                  <option [value]="undergroundZone.value">
                    {{ undergroundZone.display | translate }}
                  </option>
                }
              </select>
            </div>
            <div class="half-block">
              <label i18n="@@seasonTicketsDeliveryType" for="season-tickets-delivery-type">
                Delivery type
              </label>
              <select
                class="combo-box"
                [(ngModel)]="searchParams.deliveryType"
                id="season-tickets-delivery-type"
              >
                @for (deliveryType of searchParams.seasonTicketDeliveryTypes; track deliveryType) {
                  <option [value]="deliveryType.value">
                    {{ deliveryType.display | translate }}
                  </option>
                }
              </select>
              <p i18n="@@DeliveryIsSubject">
                Delivery is subject to the order being submitted before 12.30pm
              </p>
            </div>
          </div>
          <div class="half-container">
            <div class="half-block">
              <label i18n="@@seasonTicketsDeliveryAddress" for="season-tickets-delivery-address">
                Delivery address and postcode*
              </label>
              <textarea
                class="textarea-container"
                rows="5"
                [(ngModel)]="searchParams.deliveryAddressAndPostcode"
                id="season-tickets-delivery-address"
                [ngClass]="{
                  'error-box': searchParams.validationMessages?.includes(
                    'Please add Delivery Address and Postcode'
                  )
                }"
              >
              </textarea>
            </div>
            <div class="half-block">
              <label i18n="@@seasonTicketsPhotocardNumber" for="season-tickets-photocard-number">
                Photocard number
              </label>
              <input
                type="text"
                id="season-tickets-photocard-number"
                appInput
                name="photocardNumber"
                [(ngModel)]="searchParams.photoCardNumber"
              />
            </div>
          </div>
        </div>

        <div class="half-block">
          <label i18n="@@season-tickets-additionalInformation" for="additionalInformation">
            Additional information
          </label>
          <textarea
            rows="15"
            class="textarea-container"
            [(ngModel)]="searchParams.additionalInformation"
            id="additionalInformation"
          >
                    Notes
                  </textarea
          >
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <app-season-ticket-loading-screen></app-season-ticket-loading-screen> -->
